import { render } from "./MdpOublie.vue?vue&type=template&id=32cf1806"
import script from "./MdpOublie.vue?vue&type=script&lang=js"
export * from "./MdpOublie.vue?vue&type=script&lang=js"

import "./MdpOublie.vue?vue&type=style&index=0&id=32cf1806&lang=scss"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__